export default __webpack_public_path__ + "assets/imgs/top bg.png";